import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { getTagType, isBonusProduct } from 'base/utils/product';
import { useTrans } from 'base/utils/i18n';


type IProps = {
    product?: Record<string, any>;
    tag?: string;
    absolute?: boolean;
    placeType?: 'product' | 'order'; // 位置不同展示不一样
};

const OrderProductTag: React.FC<IProps> = props => {
    const { product, tag, absolute = true, placeType = 'product' } = props;

    const type = tag || product?.tag || getTagType(product?.productTags); //订单列表和订单页有 tag 属性，其他使用productTags
    const { t } = useTrans();

    const commonClassName = cn(
        styles.tag,
        { [styles.absolute]: absolute },
        'tag g-tag'
    );

    if (product && !product.tag && isBonusProduct(product)) {
        return (
            <div className={cn(commonClassName, styles['default-tag'])}>
                {/*{t('web_tag_bonus')}*/}
                {t('web_shop_order_perk')}
            </div>
        )
    }

    const _type = type?.toLocaleLowerCase() || ''

    switch (_type) {
        case 'surpriseegg':
            return (
                <div className={cn(commonClassName, styles['default-tag'])}>
                    {t('web_eggs_cart_prod_tag')}
                </div>
            )
        case 'earlyaccess':
            return (
                <div className={cn(commonClassName, styles['default-tag'])}>
                    {t('web_shop_activity_early_access_title')}
                </div>
            )
        case 'redeemrewards':
            return (
                <div className={cn(commonClassName, styles['default-tag'])}>
                    {t('web_common_redeem')}
                </div>
            )
        case 'slotmachine':
            return (
                <div className={cn(commonClassName, styles['default-tag'])}>
                    {t('web_tag_super_slots')}
                </div>
            )
        case 'pointsmall':
            return (
                <div className={cn(commonClassName, styles['default-tag'])}>
                    {t('web_tag_points_special')}
                </div>
            )
        case 'bonus':
            return (
                <div className={cn(commonClassName, styles['default-tag'])}>
                    {/*{t(placeType === 'product' ? 'web_tag_bonus' : 'web_shop_crowdfunding_gifts')}*/}
                    {t('web_shop_order_perk')}
                </div>
            )
        case 'xmassale':
        case 'giftbox24':
            return (
                <div className={cn(commonClassName, styles['xmas-tag'])}>
                    {t('web_tag_winter_sale')}
                </div>
            )
        default:
            return null;
    }
};

export default OrderProductTag;